import axios from 'axios';
import { getToken } from '@/utils/auth';
import { tansParams } from '@/utils/ruoyi';
import errorCode from '@/utils/errorCode';
import cache from '@/plugins/cache';
import { Message, MessageBox } from 'element-ui';
import {
  encryptBase64,
  encryptWithAes,
  generateAesKey,
  decryptWithAes,
  decryptBase64,
} from '@/utils/crypto';
import { encrypt, decrypt } from '@/utils/jsencrypt';
import store from '@/store';
import router from '@/router';
const encryptHeader = 'encrypt-key';
// 是否显示重新登录
export const isRelogin = { show: false };

export const globalHeaders = () => {
  return {
    Authorization: 'Bearer ' + getToken(),
    clientid: process.env.VUE_APP_CLIENT_ID,
  };
};

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['clientid'] = process.env.VUE_APP_CLIENT_ID;
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 300000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.url != '/auth/login') {
      console.log('config.platform:', config.platform);
      // 使用请求配置中的platform
      const platform = config.platform;
      switch (platform) {
        case 'talkytimes':
          config.baseURL = process.env.VUE_APP_BASE_API_PD;
          break;
        case 'dating':
          config.baseURL = process.env.VUE_APP_BASE_API_DT;
          break;
        case 'dating2':
          config.baseURL = process.env.VUE_APP_BASE_API_DT2;
          break;
        case 'masSending':
          config.baseURL = process.env.VUE_APP_BASE_API_MAS;
          console.log('config.baseURL:', config.baseURL);
          break;
        default:
          config.baseURL = process.env.VUE_APP_BASE_API;
          break;
      }
      // console.log('config.baseURL:', config.baseURL);
    }
    // config.baseURL = 'http://192.168.21.12:8080';
    const isToken = config.headers?.isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = config.headers?.repeatSubmit === false;
    // 是否需要加密，默认为true，除非明确设置为false
    const isEncrypt =
      config.headers.isEncrypt === undefined ? true : config.headers.isEncrypt;
    // console.log('isEncrypt', isEncrypt);、
    // console.log('config.headers:', config);
    // return
    if (getToken() && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // console.log('config.headers:', config);
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }

    if (
      !isRepeatSubmit &&
      (config.method === 'post' || config.method === 'put')
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === 'object'
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const sessionObj = cache.session.getJSON('sessionObj');
      if (
        sessionObj === undefined ||
        sessionObj === null ||
        sessionObj === ''
      ) {
        cache.session.setJSON('sessionObj', requestObj);
      } else {
        const s_url = sessionObj.url; // 请求地址
        const s_data = sessionObj.data; // 请求数据
        const s_time = sessionObj.time; // 请求时间
        const interval = 0; // 间隔时间设为0，禁用重复提交检查
        if (
          s_data === requestObj.data &&
          requestObj.time - s_time < interval &&
          s_url === requestObj.url
        ) {
          const message = '数据正在处理，请勿重复提交';
          console.warn(`[${s_url}]: ` + message);
          return message;
        } else {
          cache.session.setJSON('sessionObj', requestObj);
        }
      }
    }

    if (process.env.VUE_APP_ENCRYPT == 'true') {
      // 当开启参数加密
      if (isEncrypt && (config.method === 'post' || config.method === 'put')) {
        // 生成一个 AES 密钥
        const aesKey = generateAesKey();
        config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
        config.data =
          typeof config.data === 'object'
            ? encryptWithAes(JSON.stringify(config.data), aesKey)
            : encryptWithAes(config.data, aesKey);
      }
    }
    // FormData数据去请求头Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return error;
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    if (process.env.VUE_APP_ENCRYPT === 'true') {
      // 加密后的 AES 秘钥
      const keyStr = res.headers[encryptHeader];
      // 加密
      if (keyStr != null && keyStr != '') {
        const data = res.data;
        // 请求体 AES 解密
        const base64Str = decrypt(keyStr);
        // base64 解码 得到请求头的 AES 秘钥
        const aesKey = decryptBase64(base64Str.toString());
        // aesKey 解码 data
        const decryptData = decryptWithAes(data, aesKey);
        // 将结果 (得到的是 JSON 字符串) 转为 JSON
        res.data = JSON.parse(decryptData);
      }
    }
    // console.log('响应结果：', res);
    // 如果res.config.noTips，就不做任何提示
    if (res.config.noTips) {
      return res.data;
    }
    // 未设置状态码则默认成功状态
    if (res.data.code) {
      const code = res.data.code;
      // 获取错误信息
      const msg = errorCode[code] || res.data.msg || errorCode['default'];
      // 二进制数据则直接返回
      if (
        res.request.responseType === 'blob' ||
        res.request.responseType === 'arraybuffer'
      ) {
        return res.data;
      }
      if (code === 401) {
        console.log(isRelogin.show, 'isRelogin.show');
        if (!isRelogin.show) {
          isRelogin.show = true;
          MessageBox.confirm(
            '登录状态已过期，您可以继续留在该页面，或者重新登录',
            '系统提示',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              isRelogin.show = false;
              // useUserStore().logout().then(() => {
              store.dispatch('Logout').then(() => {
                router.replace({
                  path: '/login',
                  query: {
                    // redirect: encodeURIComponent(router.currentRoute.value.fullPath || '/')
                  },
                });
              });

              // });
            })
            .catch(() => {
              isRelogin.show = false;
            });
        }
        return res.data;
      } else if (code == 500) {
        // console.error('暂无接口：', );
        if (res.config.url == '/auth/logout') {
          return;
        }
        if (msg.includes('No static resource')) {
          console.error('暂无接口：', res.config.url);
        } else {
          Message({ message: msg, type: 'error' });
        }
        return { code: 500 };
      } else if (code != 200) {
        return res.data;
      } else {
        return res.data;
      }
    } else {
      return res.data;
    }
  },
  (error) => {
    if (error.config.noTips) return error;
    // 如果是取消请求（AbortError），不显示错误提示
    if (error.code === 'ECONNABORTED' || error.message === 'canceled' || (error.config && error.config.signal && error.config.signal.aborted)) {
      return Promise.reject(error);
    }
    if (error.status == 502) return;
    let { message } = error;
    if (message == 'Network Error') {
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    console.log('返回结果：', error);
    if (
      error.config.url.includes('/dating-api/users') &&
      error.response.status == 410
    ) {
      // 请求用户在线状态时用户不存在，不提示
    } else {
      Message({ message: message, duration: 5 * 1000, type: 'error' });
    }
    return error;
  }
);

export default service;
